export const referenceCtrls = [
    "Sales Force",
    "Obhai Driver",
    "Activation Campaign",
    "Self",
    "Facebook Post"
];

// export const riderCategory = ["BIKER", "FEMALE BIKER", "GARI", "CNG", "MICROBUS"];
export const riderCategory = [
    {
        type: 0,
        name: "GARI"
    },
    {
        type: 3,
        name: "MOTO"
    },
    {
        type: 4,
        name: "OBON"
    },
    {
        type: 5,
        name: "CNG"
    },
    {
        type: 9,
        name: "CleanCare+ CNG"
    },
    {
        type: 10,
        name: "CleanCare+ G"
    },
    {
        type: 11,
        name: "Mobile ICU Ambulance"
    },
    {
        type: 12,
        name: "AC Ambulance"
    },
    {
        type: 13,
        name: "Non-AC Ambulance"
    },
    {
        type: 14,
        name: "Freezer Ambulance"
    },
    {
        type: 15,
        name: "Air Ambulance"
    }
];

export const years = [
    2000,
    2001,
    2002,
    2003,
    2004,
    2005,
    2006,
    2007,
    2008,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
    2021
];

export const brands = [];

export const fbikeBrands = [
    "Bajaj",
    "Hero",
    "Keeway",
    "Runner",
    "Suzuki",
    "TVS",
    "Yamaha"
];
export const bikeBrands = [
    "APRILIA",
    "ATLAS ZONGSHEN",
    "BAJAJ",
    "BENNETT",
    "BETTLE BOLT",
    "DAYUN",
    "H POWER",
    "HAOJUE",
    "HERO",
    "HONDA",
    "HUNDAI",
    "KAWASAKI",
    "KEEWAY",
    "KIDEN",
    "KTM",
    "KYMCO",
    "LIFAN",
    "MAHINDRA",
    "MEIDUO",
    "MOTOCROSS",
    "PEGASUS",
    "PIAGGIO",
    "RACE",
    "REGAL RAPTOR",
    "ROADMASTER",
    "RUNNER",
    "SUZUKI",
    "SYM",
    "TVS",
    "UM",
    "VICTOR-R",
    "WALTON",
    "YAMAHA",
    "ZNEN",
    "ZONGSHEN",
    "OTHER"
];
export const carBrands = [
    "Toyota",
    "Nissan",
    "Hyundai",
    "Honda",
    "Mitsubishi",
    "Ford",
    "Suzuki",
    "Mazda"
];
export const cngBrands = ["CNG"];

export const models = [];

// Bike Models
export const apriliaModels = ["RS4 125", "SR 150"];
export const bajajModels = [
    "Pulsar 160 NS",
    "V15",
    "Pulsar 150 AS",
    "Pulsar 150 DTS-i",
    "Pulsar NS160",
    "Avenger Street 150",
    "Pulsar 150",
    "Pulsar 150 2017 Edition",
    "Pulsar 135",
    "Discover 150F",
    "Discover 150",
    "Discover 135",
    "Discover 125 ST",
    "Discover 125",
    "Discover 125 Disc",
    "Discover 100",
    "Platina ES",
    "Platina 100",
    "Platina 100 Comfortec KS",
    "Platina 100 Comfortec ES",
    "Plnatina 125",
    "CT 100",
    "CT 100 ES"
];
export const heroModels = [
    "Hunk 2016",
    "Hunk",
    "Xtreme",
    "Xtreme Sports",
    "Achiever 150",
    "Glamour",
    "Splendor iSmart 110",
    "Splendor iSmart",
    "Splendor Pro",
    "Splendor Plus",
    "Splendor Pro Classic",
    "Super Splendor",
    "Pleasure",
    "Passion Pro",
    "HF Dawn",
    "HF Deluxe"
];
export const keewayModels = [
    "Magnet 100",
    "RKS 100 v2",
    "RKS 100 v3",
    "RKS 125",
    "RKS 150 Sport CBS",
    "RKS 150 v1",
    "RKV 150",
    "Superlight 150"
];
export const runnerModels = [
    "AD80s Alloy",
    "Bike RT",
    "Bullet",
    "Cheeta",
    "Deluxe",
    "F100-6A",
    "Kite+",
    "KnightRider",
    "Royal+",
    "Turbo 125",
    "Turbo 125 Matte"
];
export const suzukiModels = [
    "Access 125",
    "Gixxer Dual Tone DD",
    "Gixxer Dual Tone SD",
    "Gixxer SF Double Disc",
    "Gixxer SF Fi",
    "Gixxer SF Fi ABS",
    "Gixxer SF MotoGP Double",
    "Gixxer SF MotoGP SD",
    "Gixxer SF Single Disc",
    "Gixxer Single Disc",
    "Gixxer SP",
    "GS150R",
    "GSX-R 150",
    "GSX-S 150",
    "GZ 150",
    "Hayate",
    "Hayate EP",
    "Intruder 150",
    "Lets",
    "Slingshot Plus",
    "Swish 125",
    "VanVan 125"
];
export const tvsModels = [
    "Apache RTR 150 Matt Blue Edition",
    "Apache RTR 150 Double",
    "Apache Hyper Edge (2012)",
    "Phoenix 125",
    "Flame SR 125",
    "Star Sport 125",
    "Metro Plus 110cc",
    "Metro Plus 110cc Disc",
    "Metro 100 KS",
    "Metro 100 ES",
    "Wego (Scooter)",
    "Scooty Pep Plus (Scooter)",
    "Jive 110",
    "XL 100",
    "Jupiter (Scooter)",
    "Stryker 125",
    "Scooty Zest 110 (Scooter)",
    "Apache RTR 160"
];
export const yamahaModels = [
    "Alpha",
    "Fascino",
    "Fazer Fi v2 2017",
    "FZ Fi v2",
    "FZS Fi Dark Night",
    "FZS Fi Matte Green",
    "FZS Fi v2 2017",
    "M-Slaz 150",
    "NMax 155",
    "R15 S",
    "R15 v2",
    "Ray Z",
    "Ray ZR",
    "Saluto Disc Brake",
    "Saluto Disc SE",
    "Saluto Drum Brake",
    "Saluto RX",
    "SZ RR Matte Green",
    "SZ-RR v2.0",
    "X Max 125",
    "Y15ZR",
    "YS125",
    "YZF-R15 v3.0"
];
export const znenModels = [
    "Aurora 125",
    "Delivery 125cc",
    "Fantasy",
    "Jog",
    "REX127 125cc",
    "RX 150 Offroad",
    "T6",
    "T6 v3 150cc",
    "T9",
    "Vento 150cc"
];
export const hundaiModels = ["GL150 Premio", "GL 100 Unique", "Deluxe 100", "Tulip 80"];
export const motocrossModels = ["Fighter 71"];
export const meiduoModels = [
    "BWS 125cc",
    "Click 125cc",
    "Falcon 150cc",
    "M Spark 125cc",
    "M6 150cc",
    "Prince 150cc",
    "Princess 150cc",
    "BWS 125cc",
    "Click 125cc",
    "Falcon 150cc",
    "M Spark 125cc",
    "M6 150cc",
    "Prince 150cc",
    "Princess 150cc"
];
export const mahndraModels = [
    "Arro XT",
    "Centuro Disc Brake",
    "Centuro N1",
    "Centuro NXT",
    "Centuro Rockstar",
    "Centuro Rockstar DLX",
    "Duro DZ",
    "Gusto 110cc",
    "Gusto 125cc",
    "Pantero",
    "Rodeo RZ"
];
export const pegasusModels = [
    "EVO 150R",
    "Zeus 150cc",
    "Fabio 125cc",
    "Victory 100cc",
    "Victory 80cc"
];
export const bennettModels = ["Benett 150", "RS2", "ZF 100-A"];
export const bettleBoltModels = [
    "Alligator",
    "Alligator v2",
    "Alpha 507",
    "Corbet",
    "iV7 50cc",
    "Mustang",
    "Stinger",
    "Viper FX125",
    "Viper GTS"
];
export const atlasZongshenModels = [
    "Z One T (150cc)",
    "Z One (150cc)",
    "150-58 (150cc)",
    "ZS125-68 (125cc)",
    "ZS 100-27 (100cc)",
    "ZS 110-56 (110cc)"
];
export const dayunModels = ["Deviser", "DY 100-A", "Plight 110", "Roebuck", "Sprout"];
export const kidenModels = [
    "KD125-J",
    "KD150-E",
    "KD150-F",
    "KD150-G",
    "KD150-H",
    "KD150-K"
];
export const hpowerModels = [
    "Cherry",
    "Dark",
    "Max",
    "Max-Z",
    "Rainbow 110",
    "Recover",
    "RoxR 150cc",
    "RS-Z",
    "RZ3 150cc",
    "Smart",
    "Star",
    "V Six",
    "Loncin GP 150 (Robot Z)",
    "Premio",
    "Robot",
    "Zaara 100",
    "Zaara 110",
    "Zaara 80"
];
export const haqjueModels = ["KA135", "Lindy ", "TR 150", "TZ"];
export const kawasakiModels = ["D-Tracker", "KLX 150 BF", "Ninja 300", "Z125"];
export const ktmModels = ["Duke 125 2017", "RC 125 2017"];
export const kymcoModels = [
    "New Like 50 (scooter)",
    "New Like 125 (Scooter)",
    "Super 8 125 (Scooter)"
];
export const lifanModels = [
    "Glint 100",
    "KP Mini 150",
    "KP 150 v2",
    "KPR 150 White Red",
    "KPR 150 2017",
    "KPS 150",
    "KPT 150"
];
export const piaggioModels = [
    "Piaggio Auge Rhino",
    "Piaggio Auge Classic",
    "Piaggio Auge Robinson 150cc",
    "Piaggio Auge Robinson 125cc",
    "Piaggio Auge 100cc"
];
export const raceModels = [
    "City 100 Alloy",
    "City 100 Spoke",
    "Fiero 150FR",
    "GSR 125",
    "Hyosung GT125",
    "Hyosung GTR125",
    "Hyosung RT125",
    "SR 125"
];
export const regalraptorsModels = [
    "OR",
    "Daytona",
    "Bobber",
    "Daelim",
    "Spyder",
    "Steller",
    "ECO-3",
    "Daystar DTS",
    "Demak DTM150 RX3",
    "DTM RX3",
    "Benyco Cruiser"
];
export const roadmasterModels = ["Delight ", "Prime", "Rapido", "Rex", "Velocity"];
export const symModels = [
    "Crox125",
    "Fiddle II 50",
    "Fiddle III 125cc",
    "GR 125cc",
    "Jet 4 125cc",
    "Jet Power 150",
    "Jet4 50",
    "Nitro 50cc",
    "Symphony S 125",
    "Tini 110cc",
    "Tonik 125cc",
    "Wol 150cc"
];
export const umModels = [
    "Xtreet",
    "Xtreet R 150",
    "Xtreet 140 R ",
    "Rengade Commando",
    "Hypersport",
    "Renegade Sport 139cc",
    "Renegade Duty 125cc",
    "Max ii 125cc",
    "Powermax 125 (Scooter)"
];
export const victorModels = [
    "V100Link",
    "110 Link Advance",
    "Classic 100",
    "V80",
    "Xpress"
];
export const waltonModels = [
    "Cruize 100",
    "Fusion 110cc",
    "Fusion 110EX",
    "Fusion 125 ",
    "Fusion 125 EX",
    "Fusion 125 NX",
    "Leo",
    "Leo New",
    "Leo+",
    "Prizm-110cc",
    "Ranger",
    "Stylex+",
    "Stylex 100",
    "Stylex New",
    "Xplore 125",
    "Xplore 140cc"
];
export const zongshenModels = [
    "CG-125-4",
    "Spark-ZS-125-70",
    "ZS-100",
    "ZS-100-4",
    "ZS-100-4A",
    "ZS-50",
    "ZS-80",
    "ZS-100-55"
];
export const hondaBikeModels = [
    "Activa 125",
    "Activa I",
    "Active 4G",
    "Aviator",
    "CB Hornet 160R",
    "CB Shine",
    "CB Shine SP125",
    "CB Trigger DD",
    "CB Trigger SD",
    "CB Twister",
    "CB Unicorn 160",
    "CB150R ExMotion",
    "CB150R Streetfire",
    "CBR 150R",
    "CBR 150R Repsol",
    "CD110 Dream DX",
    "CD80",
    "CliQ",
    "Dio",
    "Dream Neo",
    "Dream Yuga",
    "Grazia",
    "Livo Disc",
    "Livo Drum",
    "Navi",
    "NXR 160 Bros",
    "RS150R",
    "SFA 150",
    "Shadow 150",
    "Wave Alpha"
];
export const otherModels = [
    "GPX Legend 150S",
    "Derbi GPR125",
    "Megelli 150R",
    "CZ sports 150cc",
    "Frantic IS 150",
    "Yume Japan Katana",
    "MAX GROUP",
    "Motrac M3",
    "Italjet Moto Charger (Scooter)",
    "Avatar 150",
    "CFMoto 150NK"
];

// Car Models
export const toyotaModels = [
    "AE100",
    "AE-110",
    "AE110 SE Saloon",
    "Alffa-Honda",
    "Allion",
    "Allion A15",
    "ALLION A15 G+",
    "Allion G A18",
    "Allion G Edition",
    "Allion-G Ltd",
    "Aqua Hybrid",
    "Assista",
    "Auris",
    "Auris S",
    "Avanza",
    "Axio",
    "AXIO G",
    "Axio X",
    "AXIO X",
    "AXIO X 141",
    "Axio X Fielder",
    "Axio-X",
    "Belta Pearl",
    "Cami",
    "Camry",
    "Camry Hydrid",
    "Carina My Road",
    "Carina Ti",
    "Corolla",
    "Corolla G",
    "Corolla X",
    "Corona",
    "Corona premio",
    "Corona Select",
    "Corsa",
    "EE111",
    "EE89",
    "EE90",
    "F Premio",
    "F Premio G Superior",
    "Fielder",
    "FIELDER X 141",
    "Fielder X Pkg",
    "G Aero Tourer WXB",
    "GLI",
    "Harrier Hybrid",
    "Hi-Lux",
    "Isis",
    "Kluger",
    "KR 42",
    "Land Cruiser",
    "Land Cruiser Prado",
    "Lexus-F-Sports",
    "LX Limited",
    "LX100",
    "Mark-II",
    "Passo",
    "Premio",
    "Premio Corona",
    "Premio Ex",
    "Premio F-EX",
    "Premio FL",
    "Probox",
    "Probox DX",
    "Raum",
    "RAV 4",
    "RAV 5",
    "S.T Wagon",
    "S.T.Wagon",
    "SE Limited 100",
    "SE Saloon",
    "Spasio",
    "Starlet Carat",
    "Starlet Soleil",
    "Succeed",
    "Vitz",
    "Vitz F",
    "Wagon 100",
    "Wish",
    "x corolla",
    "X Fielder",
    "XE Saloon"
];
export const suzukiCarModels = ["Alto lxi", "Liana"];
export const nissanModels = [
    "X Trail",
    "Cefiro",
    "Sunny",
    "Sunny EX Saloon",
    "March",
    "Patrol",
    "Juke"
];
export const hondaModels = ["Crv", "Vezel Z", "Odyssey"];
export const hyundaiModels = ["Sonata", "Tucson"];
export const mitsubishiModels = ["Pajero", "Outlander", "Santa Fe", "Lancer"];
export const mazdaModels = ["Axela", "CX 5"];
export const fordModels = ["Fiesta"];

// CNG Models
export const cngModels = ["CNG"];

// Cities
export const cities = [
    'Dhaka',
    'Chittagong',
    'Sylhet',
    'Cumilla',
    'Coxs Bazar',
    'Rajshahi',
    'Jessore',
    'Khulna',
    'Bogura',
    'Noakhali',
    'Barisal',
    'Rangpur',
    "Bagerhat",
    "Bandarban",
    "Barguna",
    "Bhola",
    "Brahamanbaria",
    "Chandpur",
    "Chuadanga",
    "Dinajpur",
    "Faridpur",
    "Feni",
    "Gaibandha",
    "Gazipur",
    "Gopalganj",
    "Habiganj",
    "Jamalpur",
    "Jhalokati",
    "Jhenaidah",
    "Joypurhat",
    "Khagrachhari",
    "Kishoreganj",
    "Kurigram",
    "Kushtia",
    "Lakshmipur",
    "Lalmonirhat",
    "Madaripur",
    "Magura",
    "Manikganj",
    "Maulvibazar",
    "Meherpur",
    "Munshiganj",
    "Mymensingh",
    "Naogaon",
    "Narail",
    "Narayanganj",
    "Narsingdi",
    "Natore",
    "Nawabganj",
    "Netrakona",
    "Nilphamari",
    "Pabna",
    "Panchagarh",
    "Patuakhali",
    "Pirojpur",
    "Rajbari",
    "Rangamati",
    "Satkhira",
    "Shariatpur",
    "Sherpur",
    "Sirajganj",
    "Sunamganj",
    "Tangail",
    "Thakurga]on",
];

export const areas = [];

export const dhkAreas = [
    "Abdullahpur",
    "Adabor ",
    "Agargaon  ",
    "Airport  ",
    "Ansar Camp  ",
    "Arambag",
    "Azampur ",
    "Azimpur  ",
    "Badda ",
    "Bakshi Bazar  ",
    "Balughat",
    "Banani ",
    "Banani D.O.H.S",
    "Banasree ",
    "Bangla Motor  ",
    "Baridhara D.O.H.S",
    "Bashtola ",
    "Bashundhara Residential Area",
    "Bhashantak",
    "Bijoy Sarani ",
    "Bongo Bazar",
    "Chairman Bari ",
    "Chankhar Pool  ",
    "Chiriyakhana",
    "Dainik Bangla Mor ",
    "Darussalam ",
    "Demra  ",
    "Dhakeshwari ",
    "Dhanmondi 15  ",
    "Dhanmondi 27 ",
    "Dhanmondi 32 ",
    "Dia bari",
    "Duaripara ",
    "ECB Square  ",
    "Elephant Road",
    "Eskaton",
    "Farmgate ",
    "Fokirapul",
    "Fulbaria ",
    "Gabtoli ",
    "Gulistan ",
    "Gulshan 1",
    "Gulshan 2 ",
    "House Building ",
    "Indira Road",
    "Ittefaq Moar ",
    "Jashimuddin  ",
    "Jatrabari",
    "Jonopoth Mor ",
    "Kafrul",
    "Kakrail",
    "Kalabagan",
    "Kalachandpur",
    "Kallayanpur",
    "Kallyanpur ",
    "Kalshi  ",
    "Kalyanpur ",
    "Kamar Para",
    "Kamlapur ",
    "Karwan Bazar ",
    "Katabon  ",
    "Kazipara  ",
    "Khamarbari ",
    "Khilkhet ",
    "Komlapur  ",
    "Kuril Bishwa Road  ",
    "Maddhaya Badda  ",
    "Malibag ",
    "Manikdi",
    "Matikata",
    "Merul",
    "Mirpur D.O.H.S",
    "Mirpur Section-1 ",
    "Mirpur Section-10  ",
    "Mirpur Section-11 ",
    "Mirpur Section-12",
    "Mirpur Section-14",
    "Mirpur Section-14 ",
    "Mirpur Section-2 ",
    "Mirpur Section-6",
    "Moghbazar ",
    "Mohakhali ",
    "Mohakhali D.O.H.S",
    "Mohammadpur (Dhaka)",
    "Motijheel ",
    "Mouchak ",
    "Mugda ",
    "Nabisco ",
    "Nadda ",
    "Nakhalpara",
    "Natun Bazar",
    "Naya Bazar ",
    "Naya Paltan",
    "New Market ",
    "Niketan",
    "Nikunja-1",
    "Nikunja-2",
    "Nilkhet",
    "Pallabi",
    "Press Club",
    "Purana Paltan",
    "Purobi ",
    "Rajlakshmi  ",
    "Rampura ",
    "Ray Shaheb Bazar  ",
    "Rupnagar",
    "Sadarghat",
    "Satrasta",
    "Sayedabad  ",
    "Shahbag ",
    "Shahjadpur ",
    "Shankar ",
    "Shantinagar",
    "Shegun Bagicha",
    "Shewra  ",
    "Shewrapara ",
    "Shia Masjid  ",
    "Shukrabad",
    "Shyamoli",
    "Sobhanbagh",
    "Taltola ",
    "Tejgaon",
    "Tikatuli",
    "TSC ",
    "Uttar Badda  ",
    "Uttara Section-1",
    "Uttara Section-11",
    "Uttara Section-12",
    "Uttara Section-4",
    "Uttara Section-6",
    "Uttara Section-7",
    "Victoria Park",
    "Wari",
    "Wireless Moar  ",
    "Zigatola "
];

export const ctgAreas = [
    "A K Khan Moar",
    "Agrabad",
    "Airport",
    "Alankar",
    "Ambagan",
    "Amirbagh",
    "Anderkilla",
    "Askar Dighi",
    "B M Gate",
    "Badamtali",
    "Bahaddarhat ",
    "Bahaddarhat 1 kilometer",
    "Bahaddarhat Bus Terminal",
    "Bahaddarhat Police Station",
    "Bakalia",
    "Baluchara",
    "Bandar Post Office",
    "Bandar Tila",
    "Bandartila",
    "Banur Bazar",
    "Barek Building",
    "Batali Hill",
    "Battery Goli",
    "Bayezid",
    "Bepari Para",
    "Bhatiary",
    "Boddho Mondir",
    "Boro Poll",
    "Bou Bazar",
    "Boxirhat",
    "CDA Avenue",
    "CDA R/A",
    "Cement Crossing",
    "Central Shaheed Minar",
    "Chamra Gudam",
    "Chandanpura",
    "Chandgaon R/A",
    "Chatteswari Road",
    "Chawkbazar",
    "Cheragi Pahar",
    "Chowmuni",
    "City Gate",
    "CMP Rastar Matha",
    "College Road",
    "CRB",
    "Customs Bridge",
    "Customs Moar",
    "D C Hill",
    "Deb Pahar",
    "Dewan Bazar",
    "Dewan Haat",
    "Dry Dock",
    "E.P.Z",
    "Enayet Bazar",
    "Fakir Haat",
    "Fateyabad",
    "Flotila",
    "Fokirhaat Overbridge",
    "Fowzdarhat ",
    "Foys Lake",
    "Garibullah Shah Mazar",
    "GEC",
    "Goasi Bagan",
    "Golpahar Moar",
    "Halishahar ",
    "Hamzarbagh",
    "Ispahani Bridge",
    "Ispahani Moar",
    "Jalalabad Housing",
    "Jamal Khan",
    "Jela Police Line",
    "Jhawtala ",
    "Johur Ahmed Chowhdury Stadium",
    "Jubilee Road",
    "Kalamiya Bazar",
    "Kalurghat Bridge",
    "Kapasgola",
    "Kaptay Rastar Matha",
    "Karnaphuly Bridge",
    "Katalganj",
    "Katgor",
    "Kattali",
    "Kazir Dewri",
    "Khatunganj",
    "Kornel Haat",
    "Kotwali Moar",
    "Koylar Dipu",
    "Lal Dighi",
    "Lalkhan Bazar ",
    "Lichubagan",
    "Lovelane",
    "M A Aziz Stadium",
    "M.M. Ali Road",
    "Madarbari",
    "Maizpara",
    "Medical",
    "Medical Hostel",
    "Mehedibag",
    "Mistripara",
    "Mohammadpur (Chittagong)",
    "Momin Road",
    "Muradpur",
    "Nandir Haat",
    "Nasirabad Housing Society",
    "Naya Bazar",
    "New Market CTG",
    "Nimtola Bridge",
    "O.R.Nizam Road",
    "Old Railway Station",
    "Oxygen Moar",
    "Pahartali",
    "Panchlaish",
    "Parade Ground",
    "Patharghata",
    "Polytechnic",
    "Port Connecting Road",
    "Prabartak Moar",
    "Rahmatganj",
    "Rajakhali",
    "Rajmukut",
    "Reazuddin Bazar",
    "Ruby Gate",
    "Sea Beach",
    "Shalashahar",
    "Sher Shah Colony",
    "Shishu Park ",
    "Sholokbohor",
    "Sholoshohor 2 No. Gate",
    "Sirajuddowla Road",
    "Solt Gola",
    "Standard Asiatic Oil",
    "Steel Mill Bazar",
    "Sugandha",
    "Surson Road",
    "Teen Poler Matha",
    "Tigerpass",
    "USTC ",
    "Wapda Gate",
    "Wasa Moar",
    "Wireless Colony"
];

export const sylhetAreas = [
    "Akhalia",
    "Airport",
    "Alampur",
    "Amberkhana",
    "Arambag",
    "Badambagicha",
    "Baghbari",
    "Baluchar",
    "Barowbazar",
    "Barutkhana",
    "Botteshor",
    "Cadet College",
    "Chandipool",
    "Charadighirpar",
    "Chashnipir Mazar",
    "Chowhatta",
    "Chowkidekhi",
    "Dargahgate",
    "Darson Dewri, Paira",
    "Dhopadighirpar",
    "Electric Supply Road",
    "Fazilchisth",
    "Gotatikor Bcic Nagar",
    "Hasan market, Bandor",
    "Housing Estate",
    "Humayun Chattar",
    "Jail Road",
    "Jalalabad",
    "Jallarpar",
    "Kadomtoli",
    "Kajirbazar, Zitu Miah",
    "Kalighat",
    "Kamalbazar",
    "Karimullah mkt bandor",
    "Kazitola",
    "Keane Bridge",
    "Khadimpara (BIDC)",
    "Khasdogir",
    "Khoradipara",
    "Kumargaon",
    "Kumarpara Point",
    "Lakkatura",
    "Laldighir Par",
    "Lamabazar",
    "Madina Market",
    "Majumdari",
    "Medical Road",
    "Mehendibag",
    "Mejortilla",
    "Mirabazar",
    "Mirboxtola",
    "Mirer Moydan",
    "Mirzazangal",
    "Mohajonpotti",
    "Naiorpool",
    "Natun Bazar",
    "Naya Sarak",
    "Noya Bazar",
    "Pathantula",
    "Pir Maholla",
    "Pirer Bazar",
    "Pirojpur",
    "Railgate, Barthkhola",
    "Razargoli",
    "Sadhotokor",
    "Shahi Eidgah",
    "Shahporan",
    "Shibbari",
    "Shibganj",
    "Sobhanighat",
    "Subidbazar",
    "Surmagate",
    "Taltola North East",
    "TB Gate",
    "Tilaghar",
    "Tuker Bazar",
    "Uposhahar",
    "Zakiganj Road",
    "Zindabazar"
];

export const coxsAreas = [
    "Airport road",
    "Bahar chara ",
    "Barmiz market",
    "Bazar Ghata",
    "Bilkis market ",
    "Bus terminal",
    "Doria Nagar",
    "Himchori ",
    "Holiday mor",
    "Inani",
    "Kalur dokan",
    "Kolatoli",
    "Laboni point ",
    "Lal dhigir par",
    "Light house",
    "Link road",
    "Pan bazar road",
    "Rediant fish world",
    "Sugandha point"
];

export const khulnaAreas = ['Khulna Shodor'];
export const jessoreAreas = ['Jessore Shodor'];
export const rajAreas = ['Rajshahi Shodor'];
export const bogAreas = ['Bogura Shodor'];
export const noaAreas = ['Noakhali Shodor'];
export const cumAreas = ['Cumilla Shodor'];
export const barAreas = ['Barisal Shodor'];
export const rangAreas = ['Rangpur Shodor'];
export const bagerhatAreas = ['Bagerhat Shodor'];
export const bandarbanAreas = ['Bandarban Shodor'];
export const bargunaAreas = ['Barguna Shodor'];
export const bholaAreas = ['Bhola Shodor'];
export const brahamanbariaAreas = ['Brahamanbaria Shodor'];
export const chandpurAreas = ['Chandpur Shodor'];
export const chuadangaAreas = ['Chuadanga Shodor'];
export const dinajpurAreas = ['Dinajpur Shodor'];
export const faridpurAreas = ['Faridpur Shodor'];
export const feniAreas = ['Feni Shodor'];
export const gaibandhaAreas = ['Gaibandha Shodor'];
export const gazipurAreas = ['Gazipur Shodor'];
export const gopalganjAreas = ['Gopalganj Shodor'];
export const habiganjAreas = ['Habiganj Shodor'];
export const jamalpurAreas = ['Jamalpur Shodor'];
export const jhalokatiAreas = ['Jhalokati Shodor'];

export const jhenaidahAreas = ['Jhenaidah Shodor'];
export const joypurhatAreas = ['Joypurhat Shodor'];
export const khagrachhariAreas = ['Khagrachhari Shodor'];
export const kishoreganjAreas = ['Kishoreganj Shodor'];
export const kurigramAreas = ['Kurigram Shodor'];
export const kushtiaAreas = ['Kushtia Shodor'];
export const lakshmipurAreas = ['Lakshmipur Shodor'];
export const lalmonirhatAreas = ['Lalmonirhat Shodor'];
export const madaripurAreas = ['Madaripur Shodor'];
export const maguraAreas = ['Magura Shodor'];
export const manikganjAreas = ['Manikganj Shodor'];
export const maulvibazarAreas = ['Maulvibazar Shodor'];
export const meherpurAreas = ['Meherpur Shodor'];
export const munshiganjAreas = ['Munshiganj Shodor'];
export const mymensinghAreas = ['Mymensingh Shodor'];
export const naogaonAreas = ['Naogaon Shodor'];
export const narailAreas = ['Narail Shodor'];
export const narayanganjAreas = ['Narayanganj Shodor'];
export const narsingdiAreas = ['Narsingdi Shodor'];
export const natoreAreas = ['Natore Shodor'];
export const nawabganjAreas = ['Nawabganj Shodor'];
export const netrakonaAreas = ['Netrakona Shodor'];
export const nilphamariAreas = ['Jamalpur Shodor'];
export const pabnaAreas = ['Pabna Shodor'];

export const panchagarhAreas = ['Panchagarh Shodor'];
export const patuakhaliAreas = ['Patuakhali Shodor'];
export const pirojpurAreas = ['Pirojpur Shodor'];
export const rajbariAreas = ['Rajbari Shodor'];
export const rangamatiAreas = ['Rangamati Shodor'];
export const satkhiraAreas = ['Satkhira Shodor'];
export const shariatpurAreas = ['Shariatpur Shodor'];
export const sherpurAreas = ['Sherpur Shodor'];
export const sirajganjAreas = ['Sirajganj Shodor'];
export const sunamganjAreas = ['Sunamganj Shodor'];
export const tangailAreas = ['Tangail Shodor'];
export const thakurgaonAreas = ['Thakurgaon Shodor'];


export const vehicleSeries =["Ka","Kha","Ga","Taw","Tha","Da","Ha","La","Cha"]